var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.417 6.844V1H4.563C3.973 1 3.5 1.46 3.5 2.031V21.97C3.5 22.54 3.974 23 4.563 23h14.875c.588 0 1.062-.46 1.062-1.031V7.875h-6.02c-.585 0-1.063-.464-1.063-1.031zm-7.084-2.75c0-.19.159-.344.354-.344h3.542c.196 0 .354.154.354.344v.687c0 .19-.158.344-.354.344H6.688a.349.349 0 0 1-.355-.344v-.687zm0 2.75c0-.19.159-.344.354-.344h3.542c.196 0 .354.154.354.344v.687c0 .19-.158.344-.354.344H6.688a.349.349 0 0 1-.355-.344v-.687zM14.87 17.5h2.09c.39 0 .708.308.708.688 0 .38-.317.687-.709.687H14.87a1.91 1.91 0 0 1-1.71-1.025.493.493 0 0 0-.45-.28.486.486 0 0 0-.444.266l-.34.659a.71.71 0 0 1-.684.377.703.703 0 0 1-.62-.468l-.746-2.168-.47 1.37a1.907 1.907 0 0 1-1.815 1.269h-.548a.698.698 0 0 1-.709-.688c0-.38.317-.687.709-.687h.548a.495.495 0 0 0 .471-.33l.806-2.347c.146-.421.55-.705 1.008-.705.458 0 .862.283 1.008.705l.615 1.79c.875-.696 2.392-.418 2.921.608.09.174.264.279.45.279zM20.19 5.512 15.856 1.3c-.2-.194-.47-.301-.753-.301h-.27v5.5H20.5v-.262c0-.27-.11-.533-.31-.726z",
    fill: "#6173FE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/icon-archive.977f7e3a.svg";
export { ForwardRef as ReactComponent };